import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";

const ImpactSection: React.FC = () => {
  return (
    <section className="impact-section py-5">
      <Container>
      <h2 className="text-center mb-5 impact-title">Building a Brighter Future</h2>
        <Row className="text-center">
          <Col md={3} sm={6} xs={12} className="mb-4">
            <div className="impact-box">
              <h3 className="impact-number">
                <CountUp end={17} duration={2.5} suffix="+" />
              </h3>
              <p className="impact-text">Students Educated</p>
            </div>
          </Col>
          <Col md={3} sm={6} xs={12} className="mb-4">
            <div className="impact-box">
              <h3 className="impact-number">
                <CountUp end={10} duration={2.5} suffix="+" />
              </h3>
              <p className="impact-text">Skills Trained</p>
            </div>
          </Col>
          <Col md={3} sm={6} xs={12} className="mb-4">
            <div className="impact-box">
              <h3 className="impact-number">
                <CountUp end={15} duration={2.5} suffix="+" />
              </h3>
              <p className="impact-text">Healthcare Beneficiaries</p>
            </div>
          </Col>
          <Col md={3} sm={6} xs={12} className="mb-4">
            <div className="impact-box">
              <h3 className="impact-number">
                <CountUp end={20} duration={2.5} suffix="+" />
              </h3>
              <p className="impact-text">Women Empowered</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ImpactSection;
